import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
/* Layout */
import Layout from '@/layout';
import { require } from '@/utils/index';

const centerRoutes_chinese = [
    //服务协议和隐私政策
    {
      path: '/chService',
      name: '服务协议',
      component: () => import('@/views/servicePolicy/chService.vue'),
      meta: {  }
    },
    {
      path: '/chPolicy',
      name: '隐私政策',
      component: () => import('@/views/servicePolicy/chPolicy.vue'),
      meta: {  }
    },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue'),
    meta: { title: '登录', icon: 'home', hide: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/center/register.vue'),
    meta: { title: '注册', icon: 'home', hide: true }
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import('@/views/center/resetPassword.vue'),
    meta: { title: '重置密码', icon: 'home', hide: true }
  },
  {
    path: '/confirmPassword',
    name: 'ConfirmPassword',
    component: () => import('@/views/confirmPassword.vue'),
    meta: { title: '确认密码', icon: 'home', hide: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: { title: '工作区', icon: require('@/assets/images/center/menu_dashboard.png'), hide: true },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/center/dashboard/dashboard.vue')
      },
      {
        path: 'completeOrderWallet',
        name: 'CompleteOrderWallet',
        component: () => import('@/views/completeOrderWallet.vue'),
        meta: {
          title: '余额充值',
          icon: require('@/assets/images/center/menu_rocket_wallet.png'),
          hide: true  // 添加这一行来隐藏菜单项
        }
      },
    ]
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product/price',
    name: 'Product',
    meta: { title: '基本产品', icon: require('@/assets/images/center/home_icon.png'), hide: true },
    children: [
      {
        path: 'price',
        name: 'Price',
        component: () => import('@/views/center/product/proxyList.vue'),
        // meta: { title: '住宅代理', icon: require('@/assets/images/center/menu_price.png') }
      },
    ]
  },
  {
    path: '/mobility',
    component: Layout,
    redirect: '/mobility/price',
    name: 'Mobility',
    meta: { title: '移动产品', icon: require('@/assets/images/center/mobility.png'), hide: true },
    children: [
      {
        path: 'price',
        name: 'mobilityPrice',
        component: () => import('@/views/center/mobility/proxyList.vue')
      }
    ]
  },
  {
    path: '/infinite',
    component: Layout,
    redirect: '/infinite/infinitePlans',
    name: 'Infinite',
    meta: { title: '无限产品', icon: require('@/assets/images/center/infinite.png') },
    children: [
      {
        path: 'infinitePrice',
        name: 'InfinitePrice',
        component: () => import('@/views/center/infinite/infinitePrice.vue'),
        meta: { title: '无限代理' }
      },
      {
        path: 'infinitePlans',
        name: 'InfinitePlans',
        component: () => import('@/views/center/infinite/infinitePlans.vue'),
        meta: { title: '无限详情' }
      },
      {
        path: 'completeOrderInfinite',
        name: 'CompleteOrderInfinite',
        component: () => import('@/views/completeOrderInfinite.vue'),
        meta: { title: '完成订单', hide: true }
      }
    ]
  },
  {
    path: '/staticState',
    component: Layout,
    redirect: '/staticState/staticPrice',
    name: 'StaticState',
    meta: { title: '静态产品', icon: require('@/assets/images/center/static.png'), hide: true },
    children: [
      {
        path: 'staticPrice',
        name: 'StaticPrice',
        component: () => import('@/views/center/staticState/staticList.vue')
      },
      {
        path: 'completeOrderstatic',
        name: 'CompleteOrderstatic',
        component: () => import('@/views/completeOrderstatic.vue'),
        meta: { title: '结算订单', icon: require('@/assets/images/center/menu_rocket_wallet.png'), hide: true }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: '/account/profile',
    name: 'Account',
    meta: { title: '账户管理', icon: require('@/assets/images/center/ge_ren.png') },
    children: [
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/center/account/profile.vue'),
        meta: { title: '基本资料', icon: require('@/assets/images/center/profile.png') }
      },
      {
        path: 'billings',
        name: 'Billings',
        component: () => import('@/views/center/account/billings.vue'),
        meta: { title: '消费记录', icon: require('@/assets/images/center/menu_billings.png') }
      },
    ]
  },
  {
    path: '/cooperation',
    name: 'Cooperation',
    component: Layout,
    redirect: '/cooperation/index',
    meta: { title: '合作联盟', icon: require('@/assets/images/center/bang_zhu.png') },
    children: [
      {
        path: 'referralBonus',
        name: 'ReferralBonus',
        component: () => import('@/views/center/cooperation/Union.vue'),
        meta: { title: '推荐奖励', icon: require('@/assets/images/center/menu_billings.png') }
      },
      {
        path: 'partner',
        name: 'Partner',
        component: () => import('@/views/center/cooperation/partner.vue'),
        meta: { title: '合作伙伴' }
      },
    ]
  },
  {
    path: '/helpCenter',
    name: 'HelpCenter',
    component: Layout,
    redirect: '/helpCenter/index',
    meta: { title: '文档与支持', icon: require('@/assets/images/center/bang_zhu.png') },
    children: [
      {
        path: 'guide',
        name: 'HelpCenterGuide',
        component: () => import('@/views/center/helpCenter/guide.vue'),
        meta: { title: '新手指南' }
      },
      {
        path: 'index',
        name: 'HelpCenterIndex',
        component: () => import('@/views/center/helpCenter/index.vue'),
        meta: { title: '操作手册' }
      },
      {
        path: 'faq',
        name: 'HelpCenterFAQ',
        component: () => import('@/views/center/helpCenter/faq.vue'),
        meta: { title: '热门问答' }
      }
    ]
  }
];
const centerRoutes_english = [
  {
    path: '/enService',
    name: 'Service Terms',
    component: () => import('@/views/servicePolicy/enService.vue'),
    meta: {hide: true}
  },
  {
    path: '/enPolicy',
    name: 'Privacy Policy',
    component: () => import('@/views/servicePolicy/enPolicy.vue'),
    meta: {hide: true}
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue'),
    meta: { title: 'Login', icon: 'home', hide: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/center/register.vue'),
    meta: { title: 'Register', icon: 'home', hide: true }
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import('@/views/center/resetPassword.vue'),
    meta: { title: 'Reset password', icon: 'home', hide: true }
  },
  {
    path: '/confirmPassword',
    name: 'ConfirmPassword',
    component: () => import('@/views/confirmPassword.vue'),
    meta: { title: 'Confirm password', icon: 'home', hide: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: { title: 'Workspace', icon: require('@/assets/images/center/menu_dashboard.png'), hide: true },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/center/dashboard/dashboard.vue')
      },
      {
        path: 'completeOrderWallet',
        name: 'CompleteOrderWallet',
        component: () => import('@/views/completeOrderWallet.vue'),
        meta: {
          title: 'balance recharge',
          icon: require('@/assets/images/center/menu_rocket_wallet.png'),
          hide: true  // 添加这一行来隐藏菜单项
        }
      },
    ]
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product/price',
    name: 'Basic Product',
    meta: { title: 'Tool Box', icon: require('@/assets/images/center/home_icon.png'), hide: true },
    children: [
      {
        path: 'price',
        name: 'Price',
        component: () => import('@/views/center/product/proxyList.vue'),
      },
    ]
  },
  {
    path: '/mobility',
    component: Layout,
    redirect: '/mobility/price',
    name: 'Mobility',
    meta: { title: 'Mobility Proxy', icon: require('@/assets/images/center/mobility.png'), hide: true },
    children: [
      {
        path: 'price',
        name: 'mobilityPrice',
        component: () => import('@/views/center/mobility/proxyList.vue')
      }
    ]
  },
  {
    path: '/infinite',
    component: Layout,
    redirect: '/infinite/infinitePlans',
    name: 'Infinite',
    meta: { title: 'Infinite Product', icon: require('@/assets/images/center/infinite.png') },
    children: [
      {
        path: 'infinitePrice',
        name: 'InfinitePrice',
        component: () => import('@/views/center/infinite/infinitePrice.vue'),
        meta: { title: 'Infinite Proxy' }
      },
      {
        path: 'infinitePlans',
        name: 'InfinitePlans',
        component: () => import('@/views/center/infinite/infinitePlans.vue'),
        meta: { title: 'Infinite Details' }
      },
      {
        path: 'completeOrderInfinite',
        name: 'CompleteOrderInfinite',
        component: () => import('@/views/completeOrderInfinite.vue'),
        meta: { title: 'Complete order', hide: true }
      }
    ]
  },
  {
    path: '/staticState',
    component: Layout,
    redirect: '/staticState/staticPrice',
    name: 'StaticState',
    meta: { title: 'Static Product', icon: require('@/assets/images/center/static.png'), hide: true },
    children: [
      {
        path: 'staticPrice',
        name: 'StaticPrice',
        component: () => import('@/views/center/staticState/staticList.vue')
      },
      {
        path: 'completeOrderstatic',
        name: 'CompleteOrderstatic',
        component: () => import('@/views/completeOrderstatic.vue'),
        meta: { title: 'Complete Order Static', icon: require('@/assets/images/center/menu_rocket_wallet.png'), hide: true }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: '/account/profile',
    name: 'Account',
    meta: { title: 'Account Manage', icon: require('@/assets/images/center/ge_ren.png') },
    children: [
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/center/account/profile.vue'),
        meta: { title: 'Basic Information', icon: require('@/assets/images/center/profile.png') }
      },
      {
        path: 'billings',
        name: 'billings',
        component: () => import('@/views/center/account/billings.vue'),
        meta: { title: 'Consumption Records', icon: require('@/assets/images/center/menu_billings.png') }
      },
      {
        path: 'Union',
        name: 'Union',
        component: () => import('@/views/center/cooperation/Union.vue'),
        meta: { title: 'recommended rewards', icon: require('@/assets/images/center/menu_billings.png') }
      },
    ]
  },
  {
    path: '/cooperation',
    name: 'Cooperation',
    component: Layout,
    redirect: '/cooperation/index',
    meta: { title: 'Cooperative', icon: require('@/assets/images/center/bang_zhu.png') },
    children: [
      {
        path: 'referralBonus',
        name: 'ReferralBonus',
        component: () => import('@/views/center/cooperation/Union.vue'),
        meta: { title: 'Referral Bonus', icon: require('@/assets/images/center/menu_billings.png') }
      },
      {
        path: 'partner',
        name: 'Partner',
        component: () => import('@/views/center/cooperation/partner.vue'),
        meta: { title: 'Partner' }
      },
    ]
  },
  {
    path: '/helpCenter',
    name: 'HelpCenter',
    component: Layout,
    redirect: '/helpCenter/index',
    meta: { title: 'Document', icon: require('@/assets/images/center/bang_zhu.png') },
    children: [
      {
        path: 'guide',
        name: 'HelpCenterGuide',
        component: () => import('@/views/center/helpCenter/guide.vue'),
        meta: { title: 'Beginner Guide' }
      },
      {
        path: 'index',
        name: 'HelpCenterIndex',
        component: () => import('@/views/center/helpCenter/index.vue'),
        meta: { title: 'Operation Manual' }
      },
      {
        path: 'faq',
        name: 'HelpCenterFAQ',
        component: () => import('@/views/center/helpCenter/faq.vue'),
        meta: { title: 'Popular FAQ' }
      }
    ]
  }
];
const urlParams = new URLSearchParams(window.location.search);
const langParam = urlParams.get('lang');

// 根据查询参数设置 localStorage 中的语言
if (langParam === 'zh') {
  localStorage.setItem('langrage', 'chinese');
} else if (langParam === 'en') {
  localStorage.setItem('langrage', 'english'); // 默认语言
} else {
}



const lang = localStorage.getItem('langrage');
let centerRoutes = [];
if (lang === 'chinese') {
  centerRoutes = centerRoutes_chinese;
} else if (lang === 'english') {
  centerRoutes = centerRoutes_english;
} else {
  localStorage.setItem('langrage', 'english');
  centerRoutes = centerRoutes_english;
}
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: centerRoutes
});
//校验当前登录的token和user数据,没有就做相应操作
router.beforeEach(async (to, from, next) => {
  let token = localStorage.getItem('token');
  let routs = ['/register', '/Register', '/login', '/resetPassword', '/confirmPassword','/chService','/enService','/chPolicy','/enPolicy'];
  if (routs.indexOf(to.path) >= 0) {
    next();
  }
  else if (token) {
    if (!store.state.user.userInfo) {

      await store.dispatch('user/getInfo');
    }
    next();
  } else {
    next(next('/login'));
  }
});
export default router;
